import React from "react";

const CenterCard = ({ center }) => {
  return (
    <div style={styles.card}>
      <h3 style={styles.title}>{center.place_name}</h3>

      <p>📞 Ph : {center.phone_no}</p>
      <p>✉️ {center.email}</p>
      <p>📍 {center.address}</p>
    </div>
  );
};

const CenterList = ({ data }) => {
    console.log("daa of the api will be",data)
  return (
    <div style={styles.container}>
      {data.map((center, index) => (
        <CenterCard key={index} center={center} />
      ))}
    </div>
  );
};

const styles = {
   
        container: {
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          justifyContent: "center",
          backgroundColor: "#fff3ed",
          padding: "20px",
        },
        card: {
          backgroundColor: "#eef2ff",
          padding: "20px",
          borderRadius: "15px",
          width: "300px",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        },
        title: {
          fontWeight: "500",
          textTransform: "uppercase",
          marginBottom: "10px",
          whiteSpace: "nowrap",
        //   overflow: "hidden",
          textOverflow: "ellipsis",
        },
      
      
};

export default CenterList;
